import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { scListAmcs } from "../../lib/sifcontrolApi";

export default function SifControlAmcList() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        scListAmcs()
            .then((r) => setItems(r.items || []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, []);

    return (
        <section className="py-14 md:py-20" data-testid="sc-amcs-page">
            <div className="mx-auto max-w-[1240px] px-4 md:px-6">
                <div className="text-[11px] uppercase tracking-[0.24em] text-oth-ink3 font-body">AMCs</div>
                <h1 className="mt-2 font-display text-4xl md:text-5xl font-semibold tracking-tight text-oth-ink">All AMCs</h1>
                <div className="mt-8">
                    {loading ? (
                        <div className="p-10 text-center text-sm font-body text-oth-ink3">Loading…</div>
                    ) : items.length === 0 ? (
                        <div className="rounded-3xl border border-oth-line bg-white p-10 text-center text-sm font-body text-oth-ink3" data-testid="sc-amcs-empty">
                            No AMCs registered yet.
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="sc-amcs-grid">
                            {items.map((a) => (
                                <Link
                                    to={`/sifcontrol/amc/${a.id}`}
                                    key={a.id}
                                    className="rounded-2xl border border-oth-line bg-white p-5 hover:border-oth-ink/40 transition-all"
                                    data-testid={`sc-amc-card-${a.id}`}
                                >
                                    <div className="font-display text-lg font-medium text-oth-ink">{a.amc_name}</div>
                                    <div className="mt-1 text-[11px] font-body text-oth-ink3 uppercase tracking-[0.16em]">{a.short_name || " "}</div>
                                    <div className="mt-6 text-xs font-body text-oth-ink2">{a.sif_count} SIFs</div>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
